<script setup lang="ts">
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { useTheme } from '@/composables/useTheme'

useTheme()
</script>

<template>
  <router-view />
  <Toast
    :pt="{
      message: { class: '!my-2' },
      messageContent: { class: '!p-3 !gap-2' },
      messageText: { class: '!gap-1' },
      messageIcon: { class: '!text-base' },
      summary: { class: '!text-sm !font-medium !leading-tight' },
      detail: { class: '!text-xs !mt-0 !leading-tight' },
      closeButton: { class: '!w-6 !h-6' },
      closeIcon: { class: '!text-xs' },
    }"
  />
  <!--
    Global mount for PrimeVue's confirm service (useConfirm). Any component
    can call confirm.require() without needing to host its own ConfirmDialog.
    Keep this as the only mount — multiple ConfirmDialogs subscribe to the
    same service and would each render, causing double-dialog rendering.

    whitespace-pre-line on the message element lets consumers split a long
    message across lines with `\n` / `\n\n` instead of stuffing everything
    into a single sentence.
  -->
  <ConfirmDialog :pt="{ message: { class: 'whitespace-pre-line' } }" />
</template>
